import { getAdminBetaSignups, postAdminBetaSignupInvite, deleteAdminBetaSignupInvite } from '../api'

export const fetchAdminBetaSignups = async () => {
  const req = await getAdminBetaSignups()
  return { type: 'GET_ADMIN_BETA_SIGNUPS_SUCCESS', data: req.beta_signups }
}

export const sendAdminBetaSignupInvite = async (id) => {
  const req = await postAdminBetaSignupInvite(id)
  return { type: 'SEND_ADMIN_BETA_SIGNUP_INVITE_SUCCESS', data: req.beta_signup }
}
